import { CustomAction, DashboardState } from 'model/state';
import { DashboardPayload } from 'actions';
import {
  FETCH_DASHBOARD_METRICS, FETCH_DASHBOARD_METRICS_SUCCESS, FETCH_DASHBOARD_METRICS_ERROR, FETCH_DASHBOARD_ALERTS,
  FETCH_DASHBOARD_ALERTS_ERROR, FETCH_DASHBOARD_ALERTS_SUCCESS, UPDATE_DASHBOARD_ALERTS
} from 'constants/ActionTypes';

const initialState: DashboardState = {
  metrics: {
    data: {
      gauges: []
    },
    isLoading: false,
  },
  alerts: {
    isLoading: false,
    locations: [],
  },
};

function dashboardReducer(state: DashboardState | undefined = initialState, action: CustomAction<DashboardPayload>) {
  switch (action.type) {

    case FETCH_DASHBOARD_METRICS: {
      return {
        ...state,
        metrics: {
          ...state.metrics,
          isLoading: true,
        }
      }
    }

    case FETCH_DASHBOARD_METRICS_SUCCESS: {
      return {
        ...state,
        metrics: {
          ...state.metrics,
          data: action.payload?.metrics || initialState.metrics.data,
          isLoading: false,
        }
      }
    }

    case FETCH_DASHBOARD_METRICS_ERROR: {
      return {
        ...state,
        metrics: {
          ...state.metrics,
          isLoading: false,
        }
      }
    }

    case FETCH_DASHBOARD_ALERTS: {
      return {
        ...state,
        alerts: {
          ...state.alerts,
          isLoading: true,
        }
      }
    }

    case FETCH_DASHBOARD_ALERTS_ERROR:
    case FETCH_DASHBOARD_ALERTS_SUCCESS: {
      return {
        ...state,
        alerts: {
          ...state.alerts,
          isLoading: false,
        }
      }
    }

    case UPDATE_DASHBOARD_ALERTS: {
      return {
        ...state,
        alerts: {
          ...state.alerts,
          locations: action.payload?.locations || [],
        }
      }
    }

    default:
      return state
  }
}

export default dashboardReducer;
